import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { withRouter } from "react-router";
import Qs from 'query-string'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import ReservationForm from './ReservationForm'

import info_delivery from 'static/images/icons/info-delivery.svg'
import info_mail from 'static/images/icons/info-mail.svg'
import info_card from 'static/images/icons/info-card.svg'
import info_mobile from 'static/images/icons/info-mobile.svg'
import info_member from 'static/images/icons/06.svg'
import info_order from 'static/images/icons/info-order.svg'

const Instruction = props => {
    const { t } = useTranslation();
    let defaultTab = typeof props.location.state === 'number' ? props.location.state : 0
    const location = window.location
    const search = Qs.parse(location.search);
    if(!!search.tab){
        defaultTab = parseInt(search.tab)
    }

    const [activeTab, setActiveTab] = useState(defaultTab)
    const tabStyle = {
        padding: '14px 28px',
        fontWeight: 500,
        letterSpacing: '1.3px',
        fontSize: '0.875rem',
        cursor: 'pointer'
    }
    const activeTabStyle = {
        ...tabStyle,
        borderBottom: '2px solid #47c0bb'
    }
    return (
        <Grid container justify="center" style={{ marginTop: '80px' }}>
            <Grid item md={8}>
                <Grid container justify="center" style={{ marginBottom: '120px' }}>
                    <Typography style={{ fontSize: '2.25rem', color: '#0a1a1a', fontWeight: 300 }}>{t('intro_title_1')}</Typography>
                    <Typography style={{ fontSize: '2.25rem', color: '#0a1a1a', fontWeight: 300 }}>{t('intro_title_2')}</Typography>
                    <Grid container justify="center" style={{ marginTop: '24px' }}>
                        <div onClick={() => setActiveTab(0)} style={activeTab === 0 ? activeTabStyle : tabStyle}>{t('by_delivery')}</div>
                        <div onClick={() => setActiveTab(1)} style={activeTab === 1 ? activeTabStyle : tabStyle}>{t('by_on_site')}</div>
                        <div onClick={() => setActiveTab(2)} style={activeTab === 2 ? activeTabStyle : tabStyle}>{t('by_order')}</div>
                    </Grid>
                    <Grid container style={{ backgroundColor: 'white' }} className={activeTab === 0 ? '' : 'hidden'}>
                        <Grid container style={{ padding: '40px 0 60px 0' }}>
                            <Grid item md={3} style={{ textAlign: 'center' }}><img style={{ marginLeft: '80px' }} src={info_delivery} alt="" /></Grid>
                            <Grid item md={7} style={{ paddingLeft: '36px' }}>
                                <Typography style={{ fontSize: '1.25rem', fontWeight: 500, color: '#47c0bb' }}>{t('delivery_title_1')}</Typography>
                                <Typography style={{ marginTop: '8px' }}>{t('intro_location_2')}</Typography>
                                <Typography>{t('intro_location_3')}</Typography>
                                <Typography style={{ fontSize: '0.875rem', color: '#4a4f55', marginTop: '3px' }}>{t('delivery_intro_1_6')}</Typography>
                                <Typography style={{ fontSize: '0.875rem', color: '#9fa2a3' }}>{t('delivery_intro_1_8')}</Typography>
                                <Typography style={{ fontSize: '0.875rem', color: '#9fa2a3' }}>{t('delivery_intro_1_9')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ paddingBottom: '60px' }} alignItems="center">
                            <Grid item md={3} style={{ textAlign: 'center' }}><img style={{ marginLeft: '80px' }} src={info_mail} alt="" /></Grid>
                            <Grid item md={7} style={{ paddingLeft: '36px' }}>
                                <Typography style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '8px', color: '#47c0bb' }}>{t('delivery_title_2')}</Typography>
                                <Typography style={{ paddingRight: '20px' }}>{t('delivery_intro_2_1')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ paddingBottom: '60px' }} alignItems="center">
                            <Grid item md={3} style={{ textAlign: 'center' }}><img style={{ marginLeft: '80px' }} src={info_card} alt="" /></Grid>
                            <Grid item md={7} style={{ paddingLeft: '36px' }}>
                                <Typography style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '8px', color: '#47c0bb' }}>{t('delivery_title_3')}</Typography>
                                <Typography style={{ paddingRight: '20px' }}>{t('intro_to_stock_1')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ paddingBottom: '60px' }}>
                            <Grid item md={3} style={{ textAlign: 'center' }}><img style={{ marginLeft: '80px' }} src={info_mobile} alt="" /></Grid>
                            <Grid item md={7} style={{ paddingLeft: '36px' }}>
                                <Typography style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '8px', color: '#47c0bb' }}>{t('delivery_title_4')}</Typography>
                                <Typography>{t('intro_paid_1')}</Typography>
                                <Typography>{t('intro_paid_2')}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container style={{ backgroundColor: 'white' }} className={activeTab === 1 ? '' : 'hidden'}>
                        <Grid container style={{ padding: '40px 0 60px 0' }}>
                            <Grid item md={3} style={{ textAlign: 'center' }}><img style={{ marginLeft: '80px' }} src={info_member} alt="" /></Grid>
                            <Grid item md={7} style={{ paddingLeft: '36px' }}>
                                <Typography style={{ fontSize: '1.25rem', fontWeight: 500, color: '#47c0bb' }}>{t('by_on_site_title_1')}</Typography>
                                <Typography style={{ marginTop: '11px' }}>{t('intro_location_2')}</Typography>
                                <Typography>{t('intro_location_3')}</Typography>
                                <Typography style={{ fontSize: '0.875rem', color: '#9fa2a3', marginTop: '3px' }}>{t('intro_location_4')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ paddingBottom: '60px' }} alignItems="center">
                            <Grid item md={3} style={{ textAlign: 'center' }}><img style={{ marginLeft: '80px' }} src={info_card} alt="" /></Grid>
                            <Grid item md={7} style={{ paddingLeft: '36px' }}>
                                <Typography style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '8px', color: '#47c0bb' }}>{t('delivery_title_3')}</Typography>
                                <Typography style={{ paddingRight: '20px' }}>{t('intro_to_stock_1')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ paddingBottom: '60px' }}>
                            <Grid item md={3} style={{ textAlign: 'center' }}><img style={{ marginLeft: '80px' }} src={info_mobile} alt="" /></Grid>
                            <Grid item md={7} style={{ paddingLeft: '36px' }}>
                                <Typography style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '8px', color: '#47c0bb' }}>{t('delivery_title_4')}</Typography>
                                <Typography>{t('intro_paid_1')}</Typography>
                                <Typography>{t('intro_paid_2')}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container style={{ backgroundColor: 'white' }} className={activeTab === 2 ? '' : 'hidden'}>
                        <Grid container style={{ padding: '40px 0 60px 0' }}>
                            <Grid item md={3} style={{ textAlign: 'center' }}><img style={{ marginLeft: '80px' }} src={info_order} alt="" /></Grid>
                            <Grid item md={7} style={{ paddingLeft: '36px' }}>
                                <Typography style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '8px', color: '#47c0bb' }}>{t('by_order_title_1')}</Typography>
                                <Typography>{t('by_order_content')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ padding: '40px 0 60px 0' }} justify="center">
                            <ReservationForm />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default withRouter(Instruction)